export enum SessionLinkType {
	CUSTOM = 'custom',
	CALENDAR = 'calendar',
	INTERNAL = 'internal',
}

export interface SessionMeeting {
	linkType: SessionLinkType;
	linkedAccountId: number | null;
	link: string | null;
}
